import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: 'lg',
    fontFamily: 'accentMusashi',
    letterSpacing: '1px',
    fontWeight: 'normal',
    color: 'gamma.200',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    mb: ['0', null, '2'],
    textTransform: 'uppercase',
  },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: '0',
  },
  hStackWrapper: {
    justifyContent: 'flex-end',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'gamma.200',
  },
  scrollButtonGroup: {
    bg: 'none',
    boxShadow: 'none',
    variant: 'filter',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 'lg',
    gap: '1',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontFamily: 'accentMusashi',
    letterSpacing: '1px',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    color: 'gamma.200',
  },
  propositionButton: {
    variant: 'odds',
    flex: '1',
    height: '38px',
    display: 'initial',
  },
  boxSportWrapper: {
    display: 'none',
  },
  buttonSport: {
    pr: '30px',
    sx: {
      _hover: {
        color: ['gamma.200', null, null, 'alpha.700'],
        bgGradient: ['unset', null, null, 'linear(to-b, gamma.300, gamma.400)'],
      },
      ':hover:not([data-active]):not(:active)': {
        '&:after': {
          content: '""',
          position: 'absolute',
          display: 'block',
          border: '1px',
          borderColor: ['gamma.200', null, null, 'alpha.700'],
          boxSize: '2.5',
          top: '7px',
          right: '2.5',
          borderRadius: 'full',
          pr: '2',
        },
      },
      '&:after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        border: '1px',
        borderColor: 'gamma.200',
        boxSize: '2.5',
        top: '7px',
        right: '2.5',
        borderRadius: 'full',
        pr: '2',
      },
    },
  },
  buttonAllSports: {
    _active: {
      bgGradient: 'linear(to-b, gamma.300, gamma.400)',
      color: 'alpha.700',
      border: 'none',
      '&:after': {
        display: 'none',
      },
    },
  },
  segmentedButtonSortByTime: {
    color: 'gamma.200',
    _hover: {
      color: 'gamma.200',
    },
    _active: {
      bgGradient: 'linear(to-b, gamma.300, gamma.400)',
      color: 'alpha.700',
    },
  },
  segmentedButtonSortBySport: {
    color: 'gamma.200',
    _hover: {
      color: 'gamma.200',
    },
    _active: {
      bgGradient: 'linear(to-b, gamma.300, gamma.400)',
      color: 'alpha.700',
    },
  },
};
